"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BreadcrumbItem", {
    enumerable: true,
    get: function() {
        return BreadcrumbItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useBreadcrumbItem = require("./useBreadcrumbItem");
const _renderBreadcrumbItem = require("./renderBreadcrumbItem");
const _useBreadcrumbItemStylesstyles = require("./useBreadcrumbItemStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const BreadcrumbItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useBreadcrumbItem.useBreadcrumbItem_unstable)(props, ref);
    (0, _useBreadcrumbItemStylesstyles.useBreadcrumbItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useBreadcrumbItemStyles_unstable')(state);
    return (0, _renderBreadcrumbItem.renderBreadcrumbItem_unstable)(state);
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
